import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnEnvs } from "@/comn/utils";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, useToast, useModal, usePage } from "@/comn/hooks";
import { BASE, URLS, APIS, SF_LBL_LANG } from "./services/PtliLblLangPrcssService";
import { useNavigate } from "react-router-dom";

/**
 * Label processing Registration
 * !==  라벨 처리 등록 ==!
 *
 */
export const PTLI1014002S = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0001", "auth_ptli0015", "auth_ptli0061", "auth_ptlianyADM"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        lblLang: useForm({
            defaultSchema: SF_LBL_LANG,
            defaultValues: { lblId: "L_", lblTpCd: "L" },
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        //Label processing Save !==  라벨 처리 저장==!
        saveLblLang: useFetch({
            api: (lblIds) => APIS.saveLblLang(lblIds),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.00003",
                    onCancel: () => {
                        navigate(`${URLS.ptli1014001q}`);
                    },
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        //Label processing Save !==  라벨 처리 저장==!
        saveLblLang: form.lblLang.handleSubmit(
            () => {
                if (!handler.checkLblId()) return;

                const data = form.lblLang.getValues();
                modal.openModal({
                    content: "msg.00101",
                    onConfirm: () => {
                        fetch.saveLblLang.fetch(data);
                    },
                });
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.00002" });
            },
        ),
        checkLblId: () => {
            const value = form.lblLang.getValue("lblTpCd");
            const lblId = form.lblLang.getValue("lblId");

            if (lblId.substring(0, 2) !== value + "_") {
                form.lblLang.setError("lblId", {
                    message: t("msg.ptl.00779", { 0: value }),
                });
                return false;
            } else {
                form.lblLang.clearErrors("lblId");
            }
            return true;
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        form.lblLang.setFocus("lblId");
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.lblLang.schema.lblId}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control
                                    {...form.lblLang.schema.lblTpCd}
                                    onChange={() => {
                                        handler.checkLblId();
                                    }}
                                ></Group.Control>
                                <Group.Control {...form.lblLang.schema.bsopClsfCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lblLang.schema.lblNmEn}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lblLang.schema.lblNmTz}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lblLang.schema.lblNmKo}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            </form>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli1014001q);
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role="save"
                        onClick={() => {
                            handler.saveLblLang();
                        }}
                    ></Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
